import Basket from '@/_vue/components/basket/index';
import CategoryFilters from '@/_vue/components/category/filters';
import CategoryResults from '@/_vue/components/category/results';
import CheckoutPayment from '@/_vue/components/checkout/payment';
import CheckoutShipping from '@/_vue/components/checkout/shipping';
import CheckoutSummary from '@/_vue/components/checkout/summary';
import ProductImageModal from '@/_vue/components/product/image-modal';
import InputToggle from '@/_vue/components/ui/input-toggle';
import Stores from '@/_vue/components/stores/index';

export default {
    Basket,
    CategoryFilters,
    CategoryResults,
    CheckoutPayment,
    CheckoutShipping,
    CheckoutSummary,
    InputToggle,
    ProductImageModal,
    Stores,
};
